<template>
  <!-- Header -->
  <v-app-bar app clipped-left color="white">
    <!-- Logo -->
    <v-img
      class="shrink ml-md-16"
      contain
      alt="MEDGATE_"
      width="100"
      transition="scale-transition"
      :src="require('@/assets/images/medgate-logo.png')"
    ></v-img>

    <shift-schedule v-if="userType == 'tma'"></shift-schedule>

    <v-spacer></v-spacer>

    <!-- Routes -->
    <app-router
      v-for="route in routes[userType]"
      :key="route.name"
      :route-name="route.name"
    >
      {{ route.title }}
    </app-router>

    <!-- Status -->
    <app-menu-status v-if="showUserStatus"></app-menu-status>
    <!-- Profile Menu -->
    <app-menu-profile v-if="userLoggedIn" :name="fullName"></app-menu-profile>
    <!-- Login -->
    <app-login v-else></app-login>
  </v-app-bar>
</template>

<script>
export default {
  name: "AppHeader",

  components: {
    AppRouter: () => import("./AppHeaderRouter.vue"),
    AppMenuStatus: () => import("./AppHeaderMenuStatus.vue"),
    AppMenuProfile: () => import("./AppHeaderMenuProfile.vue"),
    AppLogin: () => import("./AppHeaderLogin.vue"),
    ShiftSchedule: () => import("./ShiftSchedule.vue"),
  },

  data() {
    return {
      isLoggedIn: localStorage.getItem("user"),
      routes: {
        tma: [
          { title: "Dashboard", name: "Dashboard" },
          { title: "ROR Cases", name: "Cases" },
          { title: "Schedule", name: "Schedule" },
          { title: "Chat", name: "Backroom Chat" },
        ],
        admin: [
          { title: "Dashboard", name: "Dashboard" },
          { title: "Users", name: "Users" },
          { title: "Scheduler", name: "Schedule" },
        ],
        doctor: [
          { title: "Today's Schedule", name: "Dashboard" },
          { title: "Work Schedule", name: "Schedule" },
          { title: "Preferences", name: "Preferences" },
        ],
        csr: [
          { title: "Chat", name: "Backroom Chat" },
          { title: "Notification", name: "Backroom Notification" },
        ],
      },
    };
  },

  computed: {
    fullName() {
      return this.$store.getters["profile/fullName"];
    },
    userType() {
      return this.$store.getters["profile/type"];
    },
    showUserStatus() {
      let userType = this.userType;

      return userType === "doctor";

      // return userType === "doctor" || userType === "tma"
      //   ? true
      //   : false;
    },
    userLoggedIn () {
      let userData = localStorage.getItem("user");
      return userData != null;
    }
  },
};
</script>
